/**
 * 施設区分について定義しているクラス
 */
export class FacilityClass {
  // 避難所
  static SHELTER = "1";
  // 一時集合場所
  static MEETING = "2";
  // 要配慮者施設
  static VULNER_PEOPLE = "3";
  // 避難退域時検査場所
  static INSPECTION = "4";
  static NAMES = new Map([
    [FacilityClass.SHELTER, "避難所"],
    [FacilityClass.MEETING, "一時集合場所"],
    [FacilityClass.INSPECTION, "避難退域時検査場所"]
  ]);
  constructor(value) {
    this.value = value;
    this.names = FacilityClass.NAMES;
  }

  name() {
    return this.names.get(this.value);
  }

  /**
   * valueが避難所であるかを判断する
   * @returns valueが避難所か
   */
  isShelter() {
    return this.value === FacilityClass.SHELTER;
  }

  /**
   * valueが一時集合場所であるかを判断する
   * @returns valueが一時集合場所か
   */
  isMeeting() {
    return this.value === FacilityClass.MEETING;
  }

  /**
   * valueが避難退域時検査場所であるかを判断する
   * @returns valueが避難退域時検査場所か
   */
  isInspection() {
    return this.value === FacilityClass.INSPECTION;
  }

  /**
   * valueが一時集合場所 or 避難退域時検査場所であるかを判断する
   * @returns valueが一時集合場所 or 避難退域時検査場所か
   */
  isMeetingOrInspection() {
    return (
      this.value === FacilityClass.MEETING ||
      this.value === FacilityClass.INSPECTION
    );
  }

  /**
   * valueが避難所 or 一時集合場所であるかを判断する
   * @returns valueが避難所 or 一時集合場所か
   */
  isShelterOrMeeting() {
    return (
      this.value === FacilityClass.SHELTER ||
      this.value === FacilityClass.MEETING
    );
  }

  /**
   * valueが避難所 or 避難退域時検査場所であるかを判断する
   * @returns valueが避難所 or 避難退域時検査場所か
   */
  isShelterOrInspection() {
    return (
      this.value === FacilityClass.SHELTER ||
      this.value === FacilityClass.INSPECTION
    );
  }

  /**
   * valueが要配慮者施設であるかを判断する
   * @returns valueが要配慮者施設か
   */
  isVulnerPeople() {
    return this.value === FacilityClass.VULNER_PEOPLE;
  }

  /**
   * 引数で初期化した FacilityClass を返す
   * @param {string} value facility-classで定義されている区分
   */
  static factory(value) {
    if (value == null || value === "") {
      throw new Error("施設区分が指定されていません");
    }
    return new FacilityClass(value);
  }

  /**
   * 避難所で初期化した FacilityClass を返す
   */
  static factoryShelter() {
    return new FacilityClass(FacilityClass.SHELTER);
  }

  /**
   * 要配慮者施設で初期化した FacilityClass を返す
   */
  static factoryVulnerPeople() {
    return new FacilityClass(FacilityClass.VULNER_PEOPLE);
  }

  /**
   * 要配慮者施設の区分を配列で返す
   * @returns 現在は[3]を必ず返すようになっている
   */
  static valFacilityClasses() {
    return [FacilityClass.VULNER_PEOPLE];
  }

  /**
   * 原子力防災施設の区分を配列で返す
   * @returns 現在は[1,2,4]を必ず返すようになっている
   */
  static evaFacilityClasses() {
    return [
      FacilityClass.SHELTER,
      FacilityClass.MEETING,
      FacilityClass.INSPECTION
    ];
  }
}
